export const testimonials = [
  {
    initials: 'MG',
    name: 'Mariela G.',
    location: 'Córdoba',
    role: 'Profe de E. Funcional',
    text: 'Organicé todo el año en una tarde. El sistema de benchmarks me ahorra horas cada semana. Nunca más llego al lunes sin saber qué dar.',
  },
  {
    initials: 'LP',
    name: 'Laura P.',
    location: 'Rosario',
    role: 'Profe de Entrenamiento Funcional',
    text: 'El bloque de potencia por fin tiene sentido. Los alumnos ven su progreso semana a semana y no se van más.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    role: 'Profe de E. Funcional',
    text: 'Mis clases de resistencia por fin enganchan. El Tomo 5 vale cada peso. Nunca más improviso un AMRAP.',
  },
]

export const moreTestimonials = [
  {
    initials: 'CR',
    name: 'Cecilia R.',
    location: 'Mendoza',
    role: 'Combo Completo + Método Empresario',
    text: 'Los reemplazos inteligentes me salvaron la vida. Ya no improviso cuando falta material. Mis alumnos de plaza tienen clases de la misma calidad que los de gimnasio.',
  },
  {
    initials: 'RM',
    name: 'Roberto M.',
    location: 'Buenos Aires',
    role: 'Profe de E. Funcional',
    text: 'Con el bloque de potencia del Tomo 3, en 3 semanas el grupo entero estaba haciendo KB Swing con técnica limpia. Eso no pasaba nunca antes.',
  },
  {
    initials: 'SC',
    name: 'Sofía C.',
    location: 'La Plata',
    role: 'Profe de E. Funcional',
    text: 'Mis alumnos de adaptación terminaron el Tomo 1 con tests medibles. Por primera vez puedo mostrarles su progreso con números reales.',
  },
  {
    initials: 'PA',
    name: 'Pablo A.',
    location: 'Neuquén',
    role: 'Profe de E. Funcional',
    text: 'El banco de cierres de clase fue un antes y un después. Mis alumnos ahora se van sabiendo qué lograron. La retención subió notablemente.',
  },
]

export const tomos = [
  {
    id: 'T1',
    name: 'Adaptación Funcional',
    months: 'Meses 1-2',
    content:
      'Base técnica, 7 patrones funcionales, movilidad, activación, tests iniciales',
    color: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    icon: '📘',
  },
  {
    id: 'T2',
    name: 'Fuerza Metabólica',
    months: 'Meses 3-4',
    content:
      'Carga progresiva, superseries, clusters, 5RM, metcons cronometrados',
    color: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    icon: '📗',
  },
  {
    id: 'T3',
    name: 'Potencia y CORE',
    months: 'Meses 5-6',
    content:
      'CAT, contraste de carga, KB Swing, Box Jump, complejo de potencia, CORE tridimensional',
    color: 'bg-orange-500/20 text-orange-400 border-orange-500/30',
    icon: '📙',
  },
  {
    id: 'T4',
    name: 'Hipertrofia Funcional',
    months: 'Meses 7-8',
    content: 'TUT, Rest-Pause, Myo-Reps, Drop Sets, excéntrico pesado',
    color: 'bg-red-500/20 text-red-400 border-red-500/30',
    icon: '📕',
  },
  {
    id: 'T5',
    name: 'Resistencia de Élite',
    months: 'Meses 9-10',
    content:
      'Threshold Training, HIIT funcional, Chipper, AMRAP largo, ondas de intensidad',
    color: 'bg-zinc-500/20 text-zinc-400 border-zinc-500/30',
    icon: '📓',
  },
  {
    id: 'T6',
    name: 'Peak Performance & Recuperación',
    months: 'Meses 11-12',
    content:
      'Periodización ondulatoria, tapering, re-test total del año, cierre y planificación 2026',
    color: 'bg-yellow-500/20 text-yellow-400 border-yellow-500/30',
    icon: '📔',
  },
]

export const bonuses = [
  {
    id: '01',
    icon: '🗺️',
    name: 'Mapa Anual de Clases Cero Estrés',
    desc: 'Calendario anual listo en 10 minutos. Ordena los 6 tomos por mes, objetivo y progresión.',
    value: '$8.000',
  },
  {
    id: '02',
    icon: '🎤',
    name: '52 Aperturas de Clase que te Hacen Quedar como Pro',
    desc: 'Scripts listos para empezar cualquier clase con autoridad desde el minuto cero.',
    value: '$10.000',
  },
  {
    id: '03',
    icon: '✅',
    name: 'Checklist Express Pre-Clase y Post-Clase',
    desc: 'Entrá con todo bajo control y salí sin olvidar nada importante.',
    value: '$9.000',
  },
  {
    id: '04',
    icon: '🔄',
    name: '101 Reemplazos Inteligentes de Ejercicios',
    desc: 'Si falta material, espacio o el grupo cambia, resolvés en segundos.',
    value: '$8.000',
  },
  {
    id: '05',
    icon: '🎯',
    name: 'Banco de Cierres de Clase y Frases de Retención',
    desc: 'Terminá cada clase con impacto real para que el alumno quiera volver.',
    value: '$9.000',
  },
  {
    id: '06',
    icon: '🖨️',
    name: 'Kit de Impresión Rápida para Llevar a Clase',
    desc: 'Fichas, tarjetas y planillas listas para imprimir y trabajar sin el celular.',
    value: '$9.000',
  },
]

export const faqs = [
  {
    q: '¿Sirve para todos los contextos (plaza, gym, box)?',
    a: 'Sí. El sistema está diseñado para funcionar con material estándar (kettlebells, mancuernas, bandas). El Bono 4 tiene 101 reemplazos para cuando falta material o cambia el espacio.',
  },
  {
    q: '¿Cómo recibo el material?',
    a: '100% digital. Después del pago recibís un email con el enlace de descarga en menos de 5 minutos. Podés descargarlo en cualquier dispositivo e imprimirlo si querés.',
  },
  {
    q: '¿Qué lo diferencia de otros planes de entrenamiento que encuentro online?',
    a: 'Los planes online son para alumnos. Este sistema es para el profe. Cada clase viene estructurada con bloques, cues técnicos, progresiones, regresiones, tiempos y métodos listos para ejecutar sin pensar. No es un banco de ejercicios. Es un sistema anual de 240 clases.',
  },
  {
    q: '¿Tiene garantía real?',
    a: 'Sí. 7 días, devolución completa, sin preguntas. Escribís a compradigitalyaa@gmail.com y se resuelve el mismo día.',
  },
  {
    q: '¿Funciona si soy profe principiante?',
    a: 'Sí. El Tomo 1 arranca desde la base técnica. Cada clase tiene explicaciones del método y cues para el profe, no solo para el alumno. Si recién empezás, este sistema te da la estructura que te llevaría años construir solo.',
  },
  {
    q: '¿Qué pasa si mis alumnos tienen lesiones?',
    a: 'El Combo + Método Empresario incluye protocolos de adaptación para lumbar, rodilla y hombro. Si elegís solo el Combo Completo, el Bono 4 tiene reemplazos por nivel y contexto para adaptar cualquier ejercicio.',
  },
]
